// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"7b6fc814","850":"0fafc1d9"}[chunkId] + ".chunk.js";
};